import persianJs from "persianjs";
import moment from "jalali-moment";

const mdb = window["mdb"];

export const isEmpty = (value) => {
  try {
    return typeof value === "undefined" || value === null || value === "";
  } catch (error) {
    return true;
  }
};
export const isEmptyObject = (value) => {
  try {
    return Object.keys(value).length === 0;
  } catch (error) {
    return true;
  }
};
export const isEmptyArray = (value) => {
  try {
    return Array.isArray(value) && value.length === 0;
  } catch (error) {
    return true;
  }
};
export const convertCurrencyToRial = (value) => value * 10;
export const convertCurrencyToToman = (value) => value / 10;
export const commaDigits = (value) => {
  return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};
export const complexDigitToman = (value) => {
  const convertedValue = convertCurrencyToToman(parseInt(value));
  const formattedValue = commaDigits(Math.floor(convertedValue));
  return formattedValue;
};
export const complexDigitRial = (value) => {
  const convertedValue = convertCurrencyToRial(parseInt(value));
  const formattedValue = commaDigits(Math.floor(convertedValue));
  return formattedValue;
};
export const convertPersian = (value) => {
  try {
    return persianJs(value.toString()).toEnglishNumber();
  } catch (error) {
    return value;
  }
};
export const convertMemory = (value, fromUnit, toUnit) => {
  const units = {
    B: 0,
    KB: 1,
    MB: 2,
    GB: 3,
    TB: 4,
  };

  const base = 1024;
  const fromExponent = units[fromUnit.toUpperCase()];
  const toExponent = units[toUnit.toUpperCase()];

  if (fromExponent === undefined || toExponent === undefined) {
    throw new Error("Invalid memory unit");
  }

  const exponentDiff = fromExponent - toExponent;
  const convertedValue = value * Math.pow(base, exponentDiff);

  return convertedValue;

  //console.log(convertMemory(1024, 'KB', 'MB')); تبدیل 1024 کیلوبایت به مگابایت
  //console.log(convertMemory(1, 'GB', 'TB')); تبدیل 1 گیگابایت به ترابایت
};

export const validationMessage = {
  required: "تکمیل این فیلد اجباری است.",
  requiredReg: "تکمیل {0} اجباری می‌باشد",
  remote: "لطفا این فیلد را تصحیح کنید.",
  email: "لطفا یک ایمیل صحیح وارد کنید.",
  url: "لطفا آدرس صحیح وارد کنید.",
  date: "لطفا تاریخ صحیح وارد کنید.",
  dateFA: "لطفا یک تاریخ صحیح وارد کنید.",
  dateISO: "لطفا تاریخ صحیح وارد کنید (ISO).",
  number: "لطفا عدد صحیح وارد کنید.",
  digits: "لطفا تنها رقم وارد کنید.",
  creditcard: "لطفا کریدیت کارت صحیح وارد کنید.",
  equalTo: "لطفا مقدار برابری وارد کنید.",
  extension: "فایل وارد شده صحیح نمی‌باشد.",
  alphanumeric: "لطفا مقدار را عدد (انگلیسی) وارد کنید.",
  regex: "فرمت وارد شده صحیح نمی‌باشد",
  cert: "کدملی وارد شده صحیح نمی باشد",
  charge: "مقدار باید مضربی معتبر از 1,000 بین 1,000 و 200,000 باشد ",
  onlypersian: "لطفا با حروف فارسی اطلاعات درخواستی را وارد کنید.",
  regexPersian:
    "^[\u0600-\u0605 ؐ-ؚ\u061Cـ ۖ-\u06DD ۟-ۤ ۧ ۨ ۪-ۭ ً-ٕ ٟ ٖ-ٞ ٰ ، ؍ ٫ ٬ ؛ ؞ ؟ ۔ ٭ ٪ ؉ ؊ ؈ ؎ ؏۞ ۩ ؆ ؇ ؋ ٠۰ ١۱ ٢۲ ٣۳ ٤۴ ٥۵ ٦۶ ٧۷ ٨۸ ٩۹ ءٴ۽ آ أ ٲ ٱ ؤ إ ٳ ئ ا ٵ ٮ ب ٻ پ ڀة-ث ٹ ٺ ټ ٽ ٿ ج ڃ ڄ چ ڿ ڇ ح خ ځ ڂ څ د ذ ڈ-ڐ ۮ ر ز ڑ-ڙ ۯ س ش ښ-ڜ ۺ ص ض ڝ ڞۻ ط ظ ڟ ع غ ڠ ۼ ف ڡ-ڦ ٯ ق ڧ ڨ ك ک-ڴ ػ ؼ ل ڵ-ڸ م۾ ن ں-ڽ ڹ ه ھ ہ-ۃ ۿ ەۀ وۥ ٶۄ-ۇ ٷ ۈ-ۋ ۏ ى يۦ ٸ ی-ێ ې ۑ ؽ-ؿ ؠ ے ۓ \u061D]+$",
  // maxlength: string.format("لطفا بیشتر از {0} حرف وارد نکنید."),
  // minlength: $.validator.format("لطفا کمتر از {0} حرف وارد نکنید."),
  // rangelength: $.validator.format("لطفا مقداری بین {0} تا {1} حرف وارد کنید."),
  // range: $.validator.format("لطفا مقداری بین {0} تا {1} حرف وارد کنید."),
  // max: $.validator.format("لطفا مقداری کمتر از {0} وارد کنید."),
  // min: $.validator.format("لطفا مقداری بیشتر از {0} وارد کنید."),
  // minWords: $.validator.format("لطفا حداقل {0} کلمه وارد کنید."),
  // maxWords: $.validator.format("لطفا حداکثر {0} کلمه وارد کنید."),
};
export const days_Difference = (fromDate, toDate) => {
  const oneDay = 24 * 60 * 60 * 1000; // تعداد میلی‌ثانیه‌های یک روز

  // تبدیل تاریخ‌ها به شیء تاریخ جاوا اسکریپت
  const dateObject1 = new Date(fromDate);
  const dateObject2 = new Date(toDate);

  // محاسبه تعداد روزهای اختلاف
  const diffDays = Math.round(Math.abs((dateObject1 - dateObject2) / oneDay));

  return diffDays;
};
export const gregorian_to_jalali = (date) => {
  let gregorianDate = moment(date, "YYYY-MM-DD"); // تاریخ میلادی
  let jalaliDate = gregorianDate.format("jYYYY/jMM/jDD"); // تبدیل به تاریخ شمسی
  return jalaliDate;
};
export const jalali_to_gregorian = (date) => {
  let jalaliDate = moment(date, "jYYYY/jMM/jDD"); // تاریخ میلادی
  let gregorianDate = jalaliDate.format("YYYY-MM-DD"); // تبدیل به تاریخ شمسی
  return gregorianDate;
};
export const convertToJalaliWithTime = (date, spliter = "/") => {
  let _tempDate = date.split("T")[0].split(spliter);
  return gregorian_to_jalali(
    _tempDate[0] + "/" + _tempDate[1] + "/" + _tempDate[2],
  );
};
export const convertToJalaliWithoutTime = (date, spliter = "/") => {
  let _tempDate = date.split("/");
  return gregorian_to_jalali(
    _tempDate[0] + "/" + _tempDate[1] + "/" + _tempDate[2],
  );
};
export const convertToGregorian = (date, spliter = "/") => {
  let _tempDate = date.split("/");
  return jalali_to_gregorian(
    _tempDate[0] + "/" + _tempDate[1] + "/" + _tempDate[2],
  );
};
export const formatDate = (date) => {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
};
export const getMinAndMaxDateBirthday = () => {
  let d = new Date();
  let year = d.getFullYear();
  let month = d.getMonth();
  let day = d.getDate();
  let c = new Date(year - 18, month, day);

  var MaxDate = {
    year: parseInt(formatDate(c)),
    month: 11 + 1,
    day: 30,
  };
  c = new Date(year - 100, month, day);
  var MinDate = {
    year: parseInt(formatDate(c)),
    month: month + 1,
    day: day,
  };
  return { MaxDate, MinDate };
};
export const updateInput = () => {
  document
    .querySelectorAll(".form-outline .form-control")
    .forEach((element) => {
      if (!element.classList.contains("active") && element.value.length > 0) {
        element.classList.add("active");
      }
    });
};
export const updateAllControl = () => {
  document.querySelectorAll(".form-outline").forEach((formOutline) => {
    new mdb.Input(formOutline).update();
  });
  if (isEmpty(document.querySelector(".select-wrapper")))
    document.querySelectorAll("select.select").forEach((formOutline) => {
      new mdb.Select(formOutline);
    });

  if (!isEmpty(document.querySelectorAll(".accordion"))) {
    document.querySelectorAll(".accordion").forEach((formOutline) => {
      new mdb.Collapse.getInstance(formOutline);
    });
  }
  if (!isEmpty(document.querySelectorAll(".modal"))) {
    document.querySelectorAll(".modal").forEach((formOutline) => {
      new mdb.Modal.getInstance(formOutline);
    });
  }
};
export function formatMsisdn(msisdn) {
  if (!isEmpty(msisdn)) {
    msisdn = msisdn.toString();
    return (
      msisdn.substr(0, 3) +
      " " +
      msisdn.substr(3, 3) +
      " " +
      msisdn.substr(6, 2) +
      " " +
      msisdn.substr(8, 2)
    );
  } else {
    return "";
  }
}
